export const FETCH_ASSOCIATE_TYPES = 'FETCH_ASSOCIATE_TYPES';
export const FETCH_ASSOCIATE_TYPES_SUCCESS = 'FETCH_ASSOCIATE_TYPES_SUCCESS';
export const FETCH_ASSOCIATE_TYPES_FAILURE = 'FETCH_ASSOCIATE_TYPES_FAILURE';
export const RESET_ASSOCIATE_TYPES = 'RESET_ASSOCIATE_TYPES';

export function fetchAssociateTypes() {

    return {
        type: FETCH_ASSOCIATE_TYPES,
        payload: this.state.associateTypes
    };
}

export function fetchAssociateTypesSuccess(associate_types) {
    return {
        type: FETCH_ASSOCIATE_TYPES_SUCCESS,
        payload: associate_types
    };
}

export function fetchAssociateTypesFailure(error) {
    return {
        type: FETCH_ASSOCIATE_TYPES_FAILURE,
        payload: error
    };
}



/** WEBPACK FOOTER **
 ** ./src/actions/associateTypes.js
 **/